import StepOne from "./steps/StepOne";
import StepTwo from "./steps/StepTwo";
export var HOMEPAGE_TOUR_PREFIX = "homepageTour";
var steps = [
    {
        target: "[id=\"change-homepage-view\"]",
        Content: StepOne,
        placement: "auto",
        disableBeacon: true
    },
    {
        target: "[data-tour=\"" + HOMEPAGE_TOUR_PREFIX + "-step02\"]",
        Content: StepTwo,
        placement: "auto"
    }
];
export default steps;
